import '../App.css';
import { useState } from "react";

function GameHistory({ games, players }) {
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedPlayer, setSelectedPlayer] = useState("all");
    const gamesPerPage = 5;


    const playerMap = {};
        players.forEach(p => {
        playerMap[p.id] = p.name;
    });


    const filteredGames = games.filter((game) => {
        if (selectedPlayer === "all") return true;

        const id = parseInt(selectedPlayer);

        return (
        game.player1_id === id ||
        game.player2_id === id
        );
    });

    const totalPages = Math.ceil(filteredGames.length / gamesPerPage);

    const startIndex = (currentPage - 1) * gamesPerPage;
    const paginatedGames = filteredGames.slice(
        startIndex,
        startIndex + gamesPerPage
    );


    return <>
        <div className="filter-bar">
            <select
            value={selectedPlayer}
            onChange={(e) => {
                setSelectedPlayer(e.target.value);
                setCurrentPage(1);
            }}
            >
            <option value="all">All</option>
            {players.map((player) => (
                <option key={player.id} value={player.id}>
                {player.name}
                </option>
            ))}
            </select>
        </div>

        <div className="games-box">
            {paginatedGames.map((game, index) => {
            const p1Name = playerMap[game.player1_id] || "Unknown";
            const p2Name = playerMap[game.player2_id] || "Unknown";

            const p1Delta = game.player1_rating_after - game.player1_rating_before;
            const p2Delta = game.player2_rating_after - game.player2_rating_before;

            return (
                <div key={index} className="match-card">
                <div className="match-players">
                    <span className="player-name">{p1Name}</span>
                        <span className="player-name">{game.player1_rating_before}</span>
                    <span className={p1Delta >= 0 ? "rating-up" : "rating-down"}>
                    {p1Delta >= 0 ? "+" : ""}{p1Delta}
                    </span>
                    <span className="vs-text">vs</span>
                    <span className="player-name">{p2Name}</span>
                        <span className="player-name">{game.player2_rating_before}</span>
                    <span className={p2Delta >= 0 ? "rating-up" : "rating-down"}>
                    {p2Delta >= 0 ? "+" : ""}{p2Delta}
                    </span>
                </div>
                {
                    //<div className="match-date">Date: {game.played_at.split(' ')[0]}</div>
                }

                </div>
            );
            })}
        </div>


        <div className="pagination">
            <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
            >
            Prev
            </button>

            <span style={{ margin: "0 10px" }}>
            Page {currentPage} of {totalPages}
            </span>

            <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
            >
            Next
            </button>
        </div>
    </>
}

export default GameHistory;